export default "__VITE_ASSET__DnR0Hj5q__"